module.exports = __webpack_public_path__ + "img/integration_social.64c4676c.png";